import { appLogo, playerPathwayLevel1_3, playerPathwayLevel4_5 } from '@/assets/images';
import { Stack } from '@/components/layout';
import { AppHeader } from '@/components/layout/app-header';
import { Button, Image, Text } from '@/components/ui';
import { blurTargetRefPlayerPathway } from '@/components/ui/tabbar';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { ensureOnline } from '@/libs/network/network-status';
import { NavigationService } from '@/navigations/navigation-ref';
import { colors } from '@/theme/colors';
import { BlurTargetView } from 'expo-blur';
import { StyleSheet } from 'react-native';

const listLevels = [
  {
    id: 1,
    title: STRINGS.common.playerPathwayScreen.buttons.levels1to3,
    image: playerPathwayLevel1_3,
    url: 'https://viewer.joomag.com/player-pathway-level-1-3-march2024/0371503001697045141?short&',
  },
  {
    id: 2,
    title: STRINGS.common.playerPathwayScreen.buttons.levels4to6,
    image: playerPathwayLevel4_5,
    url: 'https://viewer.joomag.com/2026-player-pathway-level-4-5/0510542001772572274',
  },
  {
    id: 3,
    title: STRINGS.common.playerPathwayScreen.buttons.levels6to8,
    image: null,
    url: null,
  },
  {
    id: 4,
    title: STRINGS.common.playerPathwayScreen.buttons.levels9to10,
    image: null,
    url: null,
  },
];

export function PlayerPathwayScreen() {
  const { scale, isTablet } = useScaling();
  const styles = useStyles();

  return (
    <BlurTargetView ref={blurTargetRefPlayerPathway} style={styles.blurTarget} collapsable={false}>
      <Stack flex={1} backgroundColor={colors['1']}>
        <AppHeader backgroundColor="white">
          <AppHeader.Left>
            <Image
              source={appLogo}
              width={scale({ phone: 57, tablet: 60 })}
              height={scale({ phone: 28, tablet: 30 })}
              resizeMode="contain"
            />
          </AppHeader.Left>

          <AppHeader.Title>
            <Text
              variant={
                isTablet
                  ? 'Font Inter/Subtitle/Bold 14px'
                  : 'Font Montserrat/Subtitle/Subtitle 2 Bold 12px'
              }
              transform="uppercase"
              fontWeight={isTablet ? undefined : '800'}
              style={styles.headerTitle}>
              {STRINGS.common.playerPathwayScreen.title}
            </Text>
          </AppHeader.Title>

          <AppHeader.Right>
            <Stack
              width={scale({ phone: 57, tablet: 60 })}
              height={scale({ phone: 28, tablet: 30 })}
            />
          </AppHeader.Right>
        </AppHeader>
        <Stack style={styles.lineDivider} />

        <Stack
          flex={1}
          align="center"
          justify={isTablet ? 'center' : 'flex-start'}
          paddingX={scale(16)}
          paddingTop={scale(16)}
          paddingBottom={scale({ tablet: 80, phone: 0 })}>
          <Stack
            gap={scale(10)}
            maxWidth={scale({ phone: 348, tablet: 830 })}
            align="center"
            justify="center"
            direction="row"
            wrap="wrap">
            {listLevels.map(level => (
              <Stack key={level.id}>
                {level.image ? (
                  <Image
                    source={level.image}
                    style={styles.image}
                    width={scale({ phone: 166, tablet: 200 })}
                    height={scale({ phone: 254, tablet: 307 })}
                  />
                ) : (
                  <Stack
                    align="center"
                    justify="center"
                    borderRadius={8}
                    width={scale({ phone: 166, tablet: 200 })}
                    height={scale({ phone: 254, tablet: 307 })}
                    backgroundColor="#F0F0F0">
                    <Text
                      fontFamily="Inter"
                      fontSize={scale(20)}
                      fontWeight="900"
                      lineHeight={scale(28)}
                      letterSpacing={0}
                      style={{ color: colors['4'] }}>
                      IN REVISION
                    </Text>
                  </Stack>
                )}
                <Button
                  skipPressStyle={!level.url}
                  onPress={async () => {
                    await ensureOnline();
                    if (level.url) {
                      NavigationService.push('PlayerPathwayWebView', { url: level.url });
                    }
                  }}
                  style={[
                    styles.actionButton,
                    {
                      width: scale({ phone: 166, tablet: 200 }),
                      height: scale({ phone: 40, tablet: 48 }),
                    },
                    level.url
                      ? {
                          backgroundColor: colors.Blue,
                        }
                      : {
                          backgroundColor: colors['3'],
                        },
                  ]}>
                  <Button.Icon
                    name="IcLink"
                    color={level.url ? colors['0'] : colors['10']}
                    size={scale({ phone: 16, tablet: 24 })}
                  />
                  <Button.Text
                    fontSize={scale({ phone: 10, tablet: 14 })}
                    fontWeight={isTablet ? '500' : '400'}
                    fontFamily="Inter"
                    style={{ color: level.url ? colors['0'] : colors['10'] }}>
                    {level.title}
                  </Button.Text>
                </Button>
              </Stack>
            ))}
            {/* <Button
              onPress={() => {
                NavigationService.push('PlayerPathwayWebView', { url: url1_3 });
              }}
              style={[
                styles.actionButton,
                {
                  width: scale({ phone: 180, tablet: 240 }),
                  height: scale({ phone: 30, tablet: 48 }),
                },
              ]}>
              <Button.Icon name="IcLink" size={scale({ phone: 16, tablet: 24 })} />
              <Button.Text
                fontSize={scale({ phone: 10, tablet: 14 })}
                fontWeight={isTablet ? '500' : '400'}
                fontFamily="Inter">
                {STRINGS.common.playerPathwayScreen.buttons.levels1to3}
              </Button.Text>
            </Button>

            <Button
              onPress={() => {
                NavigationService.push('PlayerPathwayWebView', { url: url4_5 });
              }}
              style={[
                styles.actionButton,
                {
                  width: scale({ phone: 180, tablet: 240 }),
                  height: scale({ phone: 30, tablet: 48 }),
                },
              ]}>
              <Button.Icon name="IcLink" size={scale({ phone: 16, tablet: 24 })} />
              <Button.Text
                fontSize={scale({ phone: 10, tablet: 14 })}
                fontWeight={isTablet ? '500' : '400'}
                fontFamily="Inter">
                {STRINGS.common.playerPathwayScreen.buttons.levels4to6}
              </Button.Text>
            </Button> */}
          </Stack>
        </Stack>
      </Stack>
    </BlurTargetView>
  );
}

const useStyles = createStyles(({ scale }) => ({
  blurTarget: {
    flex: 1,
  },
  headerTitle: {
    color: colors.Blue,
  },
  lineDivider: {
    width: '100%',
    height: StyleSheet.hairlineWidth,
    backgroundColor: colors['10'],
  },
  actionButton: {
    padding: 0,
    borderRadius: scale(4),
    marginTop: scale(-10),
  },
  note: {
    marginTop: scale({ phone: 14, tablet: 16 }),
    color: colors['10'],
  },
  scrollViewContent: {
    paddingBottom: scale(100),
  },
  image: {
    borderRadius: scale(8),
  },
}));
